<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="container-fluid">
    <form [formGroup]="rentalForm">
        <div class="row">
            <div class="alignMenu shadow text-left pt-2 px-1" [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
                <app-rental-menu IsVendorLogin="IsVendorLogin"  *ngIf="!hideTopHeaders" (companyIdSevenMile)="companyIdSevenMile($event)"></app-rental-menu>
            </div>
            <div class="bgMainSection bgBlue text-left" [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'">
                <div class="container mainContainer">
                    <div class="row">
                        <div class="col-5 text-left mt-4">
                            <h2 class="mainHeading mb-0">{{pageName}}</h2>
                        </div>
                        <div class="col-7 text-right pl-0 mt-4" [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
                            <h1 class="mainHeading mb-0">{{marketName}}</h1>
                        </div>
                        <div class="col-12 col-lg-2 text-left text-lg-right mt-4" *ngIf="SwapORamaCustomChanges">
                        <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
                    </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center mt-3">
                            <h1 class="welcome">Welcome {{vendorName}}</h1>
                        </div>
                    </div>
                    <div class="row" *ngIf="!hideTopHeaders">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left">
                            <button #btnRentOnline class="btn btnMain mr-3 mt-2" (click)="rentOnline()" *ngIf="anyRentalTypeEnabledForBooking && !EnableWRQBR">Rent Online</button>
                            <button #ContactInfo class="btn btnMain mr-3 mt-2" (click)="contactInfo()">Current Contact
                                Information</button>
                            <button #btnLoginInfo class="btn btnMain mr-3 mt-2" (click)="LoginInfo()">Online Login
                                Info</button>
                            <button #btnBookings class="btn btnMain mr-3 mt-2" (click)="MyBookings()">My Bookings</button>
                            <button #btnQBR class="btn btnMain mt-2" (click)="QBR()" *ngIf="Show7MileWRQBRSettings && EnableWRQBR">Quick Booth Rental</button>
                            <button #btnBidEntry class="btn btnMain mr-3 mt-2" (click)="BidEntry()" *ngIf="EnableAuction" >Bid Entry</button>
                        </div>
                    </div>
                    <div #divContactInfo class="bgWghite shadow mt-2"
                        [ngStyle]="{ display: showrentOnline ? 'block' : 'none' }">
                        <div class="container">
                            <div class="row mt-1 pl-4" *ngIf="!hideTopHeaders">
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0 mt-2" *ngIf="AllowBookingsDaily">
                                    <input type="radio" id="rdDaily" class="form-check-input" value="1" formControlName="rentalTypes" >
                                    <label for="rdDaily" class="form-check-label">Daily</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0 mt-2" *ngIf="AllowBookingsWeekly">
                                    <input type="radio" id="rdWeekly" class="form-check-input" value="3" formControlName="rentalTypes" >
                                    <label for="rdWeekly" class="form-check-label">Weekly</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0 mt-2" *ngIf="AllowBookingsMonthly">
                                    <input type="radio" id="rdMonthly" class="form-check-input" value="2" formControlName="rentalTypes" >
                                    <label for="rdMonthly" class="form-check-label">Monthly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0 mt-2" *ngIf="AllowBookingsCw">
                                    <input type="radio" id="rdCombinedWeek" class="form-check-input" value="5" formControlName="rentalTypes" >
                                    <label for="rdCombinedWeek" class="form-check-label">Combined Weekly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0 mt-2" *ngIf="AllowBookingsCm">
                                    <input type="radio" id="rdCombinedMonth" class="form-check-input" value="4" formControlName="rentalTypes" >
                                    <label for="rdCombinedMonth" class="form-check-label">Combined Monthly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsEvent">
                                    <input type="radio" id="rdCombinedMonth" class="form-check-input" value="7" formControlName="rentalTypes" >
                                    <label for="rdCombinedMonth" class="form-check-label">Event</label>
                                </div>
                            </div>
                            <div class="row mt-1 pl-2">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xl-10 ml-lg-10 ml-xl-0">
                                    <span *ngIf="this.rentalForm.value['rentalTypes'] == 1" style="color: #D7232C;font-size:12px;">Booths can be rented
                                        for single or multiple market days on a one time
                                        basis.</span>
                                    <span *ngIf="this.rentalForm.value['rentalTypes'] == 2" style="color: #D7232C;font-size:12px;">Booths can be rented for
                                        one market day per week on permanent monthly basis.</span>
                                    <span *ngIf="this.rentalForm.value['rentalTypes'] == 3" style="color: #D7232C;font-size:12px;">Booths can be rented for
                                        one market day in the week on permanent weekly basis.</span>
                                    <span *ngIf="this.rentalForm.value['rentalTypes'] == 4" style="color: #D7232C;font-size:12px;">Booth can be rented
                                        for all market days in the month on monthly basis.</span>
                                    <span *ngIf="this.rentalForm.value['rentalTypes'] == 5" style="color: #D7232C;font-size:12px;">Booths can be rented
                                        for all market days in the week on weekly basis.</span>
                                </div>
                                <div class="col-md-12 col-lg-2 col-sm-12 col-xl-2" style="display: inline-block;" >
                                    <a [href]="howtoRentSpaceDocURL" target="_blank" class="btn btn-danger py-2">How To Rent</a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <hr class="my-2" />
                                </div>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '1'">
                                <app-dailyrental-online (isFormDirty)="setDirtyFlag($event)" (isCancelClicked)="isCancelClicked($event)"></app-dailyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '2'">
                                <app-monthlyrental-online (isFormDirty)="setDirtyFlag($event)" (isCancelClicked)="isCancelClicked($event)"></app-monthlyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '3'">
                                <app-weeklyrental-online (isFormDirty)="setDirtyFlag($event)" (isCancelClicked)="isCancelClicked($event)"></app-weeklyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '4'">
                                <app-combinedmonthlyrental-online (isFormDirty)="setDirtyFlag($event)" (isCancelClicked)="isCancelClicked($event)"></app-combinedmonthlyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '5'">
                                <app-combinedweeklyrental-online (isFormDirty)="setDirtyFlag($event)" (isCancelClicked)="isCancelClicked($event)"></app-combinedweeklyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '7'">
                                <app-eventrental-online (isFormDirty)="setDirtyFlag($event)" (isCancelClicked)="isCancelClicked($event)"></app-eventrental-online>
                            </div>
                        </div>
                    </div>
                    <div #divOnlineAccess class="bgWghite shadow pt-2 mt-2"
                        [ngStyle]="{ display: showContactInfo ? 'block' : 'none' }">
                        <div class="container" formGroupName="contactInfoForm">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="firstName"><span class="required">*</span>Name:</label>
                                        <input type="text" class="form-control" formControlName="firstName" id="firstName">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="lastName"><span class="required">*</span>Last Name</label>
                                        <input type="text" class="form-control" formControlName="lastName" id="lastName">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="companyName">Company Name:</label>
                                        <input type="text" class="form-control" id="companyName" formControlName="companyName">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="address"><span class="required">*</span>Street Address:</label>
                                        <input type="text" class="form-control" id="address" formControlName="address">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="city"><span class="required">*</span>City</label>
                                        <input type="text" class="form-control" id="city" formControlName="city">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <span class="mb-0"><span class="required">*</span>State/ Province</span>

                                        <ejs-combobox id='DLStateCombobox' #DLState *ngIf="showStateDropDown" [fields]='DropDownfieldsState' [popupHeight]="200"
                                          [dataSource]='StateList' formControlName="state" [allowFiltering]='true' allowCustom=true
                                          [placeholder]="'Select State'" filterBarPlaceholder="Search for State/Province"
                                          (created)="lockStateComboBoxTranslation()" (open)="lockStateComboBoxTranslation()">
                                        </ejs-combobox>
                                        <!-- <ejs-combobox id='StateCombobox' #DLState *ngIf="!showUsStateDropDown" [fields]='DropDownfieldsState' [dataSource]='NoneUsStateList' formControlName="DLState" [allowFiltering]='true'
                                                                                                                    allowCustom=true placeholder = '' ></ejs-combobox> -->

                                        <input type="text" *ngIf="!showStateDropDown" maxlength="2" class="form-control" formControlName="state">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="ddlCountry"><span class="required">*</span>Country</label>
                                        <select id="ddlCountry" class="form-control" formControlName="country"
                                            (change)="DropDownCountryChange($event)" translate="no">
                                            <option *ngFor="let ct of countryList" [value]="ct.Code">{{ct.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <span class="mb-0" for="postalCode"><span class="required">*</span>Zip/Postal Code</span>
                                        <ejs-maskedtextbox [mask]="ZipCodeMask" *ngIf="showZipCodeAsTxt" name="ZipCode" id="ZipCode" formControlName="postalCode"
                                            (blur)="UpdateStateAndCityByZipcode()"></ejs-maskedtextbox>
                                        <input type="text" id="postalCode" *ngIf="!showZipCodeAsTxt" class="form-control" formControlName="postalCode"
                                            (blur)="UpdateStateAndCityByZipcode()">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <span class="mb-0">Work Phone</span>
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="workPhone" id="workPhone"
                                            formControlName="workPhone" (keyup)="onKeyUp('workPhone')"></ejs-maskedtextbox>
                                        <small style="color: #D7232C;" *ngIf="showWorkPhoneError" i18n>Enter valid work
                                            phone number</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <span class="mb-0"><span class="required">*</span>Cell Phone</span>
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="cellPhone" id="cellPhone"
                                            formControlName="cellPhone" (keyup)="onKeyUp('cellPhone')"></ejs-maskedtextbox>
                                        <small style="color: #D7232C;" *ngIf="showCellPhoneError" i18n>Enter valid cell
                                            phone number</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="email"><span class="required">*</span>Email</label>
                                        <input type="text" class="form-control text-left" id="email" formControlName="email"
                                        [pattern]="emailIdsPattern" (keypress)="restrictSpace($event)">
                                        <div class="alert alert-danger"
                                            *ngIf="this.rentalForm.controls['contactInfoForm'].get('email').errors && ( this.rentalForm.controls['contactInfoForm'].get('email').dirty ||  this.rentalForm.controls['contactInfoForm'].get('email').touched)">
                                            <span *ngIf=" this.rentalForm.controls['contactInfoForm'].get('email').errors.pattern" i18n>
                                                Enter valid Email ID</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3" *ngIf="companyId == 29">
                                    <div>
                                        <label class="mb-0" for="VendorDescription"><span class="required">*</span>Product Description</label>
                                        <textarea type="text" class="form-control text-left" id="VendorDescription" formControlName="VendorDescription" maxlength="350"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div class="uploadPhoto">
                                        <div class="market_logo" style="position: relative;">
                                            <div class="market_img edit_vendor_image">
                                                <img class="userIcon img-fluid"
                                                    [src]="rentalForm.controls['contactInfoForm'].get('VendorProfile').value == '' ? '../../../assets/images/NoImage.jpg' : rentalForm.controls['contactInfoForm'].get('VendorProfile').value"
                                                    loading="lazy" alt="ADD VENDOR PHOTO">
                                                <span class="btn btn-danger edit_MarketLogo float-right"
                                                    *ngIf="!isVendorPhotoLocked && rentalForm.controls['contactInfoForm'].get('VendorProfile').value != '../../../assets/images/NoImage.jpg' && rentalForm.controls['contactInfoForm'].get('VendorProfile').value != '' "
                                                    (click)="RemoveVendorImage()">
                                                    <i class="fa fa-trash"></i>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="!isVendorPhotoLocked">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                            <div class="file-upload text-center mt-2">
                                                <label for="fileVendorPhoto" class="custom-button" i18n>ADD VENDOR PHOTO</label>
                                                <input id="fileVendorPhoto" type="file" (change)="VendorPhotoUpload($event)" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div class="uploadPhoto">
                                        <div class="market_logo" style="position: relative;">
                                            <div class="market_img edit_vendor_image">
                                                <img class="userIcon img-fluid" *ngIf="VendorProductsImageList.length == 0"
                                                    (click)="ViewAllProductImages(VendorProductImages)" src="../../../assets/images/NoImage.jpg"
                                                    loading="lazy" alt="Vendor Product Image 1">
                                                <img class="userIcon img-fluid" *ngIf="VendorProductsImageList.length != 0"
                                                    (click)="ViewAllProductImages(VendorProductImages)"
                                                    [src]="VendorProductsImageList[VendorProductsImageList.length - 1].ProductImageUrl" loading="lazy" alt="Vendor Product Image 2">
                                                <span (click)="ViewAllProductImages(VendorProductImages)"
                                                    class="btn btn-primary edit_MarketLogo float-right">
                                                    <i class="fa fa-expand"></i>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="!isVendorProductPhotoLocked">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                            <!-- <div class="file-upload">
                                                <label for="fileProductPhoto" class="custom-button" i18n>
                                                    ADD PRODUCT PHOTO
                                                </label>
                                                <input id="fileProductPhoto" type="file" (change)="handleImageSelection($event)" accept="image/*" />
                                                <span class="file-name" style="display: none;" i18n>No file chosen</span>
                                            </div> -->
                                            <div class="file-upload text-center mt-2">
                                                <label for="fileProductPhoto" class="custom-button" i18n>ADD PRODUCT PHOTO</label>
                                                <input id="fileProductPhoto" type="file" (change)="handleImageSelection($event)" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-right my-3">
                                    <button class="btn btn-outline-primary mr-1" (click)="cancelContactModification()">Cancel</button>
                                    <button class="btn btn-primary" (click)="UpdateVendor()" [disabled]="validateContactForm()">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div #divLoginInfo class="bgWghite shadow pt-2 mt-2"
                        [ngStyle]="{ display: showLoginInfo ? 'block' : 'none' }">
                        <div class="container" formGroupName="onlineLoginForm">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="onlineUserName">*User Name</label>
                                        <input type="text" id="onlineUserName" class="form-control" formControlName="onlineUserName">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="onlinePassword">*Password</label>
                                        <div class="input-group">
                                            <input [type]="passwordFieldType" id="onlinePassword" class="form-control" formControlName="onlinePassword"
                                                placeholder="Enter Password" />
                                            <span class="input-group-text" (click)="togglePasswordVisibility()">
                                                <i [ngClass]="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="confirmPassword">Confirm Password</label>
                                        <div class="input-group">
                                            <input [type]="passwordFieldType" id="confirmPassword" class="form-control" formControlName="confirmPassword">
                                            <span class="input-group-text" (click)="togglePasswordVisibility()">
                                                <i [ngClass]="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="securityQuestions">*Security Question</label>
                                        <select id="ddlState" class="form-control" id="securityQuestions" formControlName="securityQuestions">
                                            <option *ngFor="let questions of securityQuestion" [value]="questions.ID">{{questions.SecurityQuestion}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="securityAnswer">*Answer</label>
                                        <input type="text" class="form-control" id="securityAnswer" formControlName="securityAnswer">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-right my-3">
                                    <button class="btn btn-outline-primary mr-1">Cancel</button>
                                    <button class="btn btn-primary" (click)="saveVendorLoginDetail()">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div #divBookings class="bgWghite shadow pt-2 mt-2"
                        [ngStyle]="{ display: showBookings ? 'block' : 'none' }" style="padding-bottom: 2rem;">
                        <div class="container">
                            <div class="row mt-1 pl-4" *ngIf="!hideTopHeaders">
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsDaily">
                                    <input type="radio" id="rdBookingsDaily" class="form-check-input" value="1" formControlName="bookingRentalTypes">
                                    <label for="rdBookingsDaily" class="form-check-label">Daily</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsWeekly || AllowRenewalsWeekly">
                                    <input type="radio" id="rdBookingsWeekly" class="form-check-input" value="3" formControlName="bookingRentalTypes">
                                    <label for="rdBookingsWeekly" class="form-check-label">Weekly</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsMonthly || AllowRenewalsMonthly">
                                    <input type="radio" id="rdBookingsMonthly" class="form-check-input" value="2" formControlName="bookingRentalTypes">
                                    <label for="rdBookingsMonthly" class="form-check-label">Monthly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsCw || AllowRenewalsCw">
                                    <input type="radio" id="rdBookingsCombinedWeek" class="form-check-input" value="5" formControlName="bookingRentalTypes">
                                    <label for="rdBookingsCombinedWeek" class="form-check-label">Combined Weekly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsCm || AllowRenewalsCm">
                                    <input type="radio" id="rdBookingsCombinedMonth" class="form-check-input" value="4" formControlName="bookingRentalTypes">
                                    <label for="rdBookingsCombinedMonth" class="form-check-label">Combined Monthly</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0" *ngIf="AllowBookingsEvent">
                                    <input type="radio" id="rdBookingsDaily" class="form-check-input" value="7" formControlName="bookingRentalTypes">
                                    <label for="rdBookingsDaily" class="form-check-label">Event</label>
                                </div>
                            </div>
                            <div *ngIf="showBookings && (this.rentalForm.value['bookingRentalTypes'] == '1' || this.rentalForm.value['bookingRentalTypes'] == '7'
                            || this.rentalForm.value['bookingRentalTypes'] == '4' || this.rentalForm.value['bookingRentalTypes'] == '5')">
                                <app-booking-details [rentalType]="this.rentalForm.value['bookingRentalTypes']" [marketId]="marketId" [vendorId]="vendorId" [paymentOnly]="paymentOnly" (hideTopHeaders)="hideAllTopHeaders($event)"></app-booking-details>
                            </div>

              <div *ngIf="showBookings && (this.rentalForm.value['bookingRentalTypes'] == '2' || this.rentalForm.value['bookingRentalTypes'] == '3')">
                <app-booking-details-weekly-monthly [rentalType]="this.rentalForm.value['bookingRentalTypes']" [marketId]="marketId" [vendorId]="vendorId" [paymentOnly]="paymentOnly" (hideTopHeaders)="hideAllTopHeaders($event)"></app-booking-details-weekly-monthly>
              </div>

            </div>
          </div>
          <div #divBookings class="bgWghite shadow pt-2 mt-2"
            [ngStyle]="{ display: showReviewRegistration ? 'block' : 'none' }">
            <div class="container">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-2">
                  <label class="mb-0" for="RegistrationFee">Registration Fee</label>
                  <br />
                  <input type="text" id="RegistrationFee" class="form-control">
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-2">
                  <span class="mb-0">Registration Exp Date</span>
                  <br />
                  <ejs-datepicker format='MM/dd/yyyy' [allowEdit]=false></ejs-datepicker>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-left">
                  <div>
                    <label class="mb-0">
                      <input type="checkbox" id="chkRenewReg" class="CheckboxClass mt-3">
                      <label class="chkAlign mb-0" for="chkRenewReg" style="margin-top: -27px !important">I authorize ABC Flea Market to charge this amount to my
                        Credit Card. Upon authorization and full payment by the issuing card
                        company, ABC Flea Market will submit a confirmation number, as verification
                        of charged transaction, to the above named cardholder.</label>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-left mt-2">
                  <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4xMjQiIGhlaWdodD0iMTUuODQzIiB2aWV3Qm94PSIwIDAgMjEuMTI0IDE1Ljg0MyI+CiAgPHBhdGggaWQ9Ikljb25fYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkPSJNMjEuMTI0LDEwLjFBMS44NiwxLjg2LDAsMCwxLDE5LjI3NiwxMS45aC00LjEyYTIuMDI5LDIuMDI5LDAsMCwxLS4yNiwyLjkyNywxLjg5LDEuODksMCwwLDEtLjY3OSwyLjU3MWMuMzcsMi4wMjctLjkwNSwyLjk0LTMsMi45NC0uMTEzLDAtLjU0OC0uMDA4LS42Ni0uMDA4LTIuNTU3LjAwNy0zLjE3Mi0xLjI4Mi01LjEtMS41ODFhLjk4OS45ODksMCwwLDEtLjgzNi0uOTc4VjEwLjdoMEExLjk4LDEuOTgsMCwwLDEsNS44LDguODljMS4xOTItLjUzNiwzLjkzNy0yLjAyMyw0LjQzNy0zLjE5YTEuNzU5LDEuNzU5LDAsMCwxLDEuNjUtMS4yQTEuOTgyLDEuOTgyLDAsMCwxLDEzLjcsNy4yNmE1LjYwOCw1LjYwOCwwLDAsMS0uNTg0LDEuMDI4aDYuMTU3QTEuODksMS44OSwwLDAsMSwyMS4xMjQsMTAuMVptLTE3LjE2My4wMTR2Ny45MjJhLjk5Ljk5LDAsMCwxLS45OS45OUguOTlhLjk5Ljk5LDAsMCwxLS45OS0uOTlWMTAuMTExYS45OS45OSwwLDAsMSwuOTktLjk5aDEuOThBLjk5Ljk5LDAsMCwxLDMuOTYxLDEwLjExMVpNMi44MDYsMTcuMDQyYS44MjUuODI1LDAsMSwwLS44MjUuODI1QS44MjUuODI1LDAsMCwwLDIuODA2LDE3LjA0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQuNSkiIGZpbGw9IiMwNzI4ZmYiLz4KPC9zdmc+Cg=="
                    class="img-fluid" alt="Arrow hand Icon" />
                  &nbsp;<a class="rules">Click here to read the Rules and Regulations</a>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-left mt-2 mb-3">
                  <div>
                    <label class="mb-0">
                      <input type="checkbox" id="chkAck" class="CheckboxClass mt-3">
                      <p class="chkAlign mb-0" for="chkAck" style="margin-top: -27px !important">By checking this box, I acknowledge that I have read,
                        understand, and agree to the rules and regulations, and will Abide by them.
                        Please visit the office for a copy of the rules and regulations</p>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div #divBookings class="bgWghite shadow pt-2 mt-2" [ngStyle]="{ display: showQBR ? 'block' : 'none' }">
            <div class="container" [formGroup]="QBRForm">
              <!-- Saturday Section -->
              <div class="row">
                <div class="col-12 text-left mt-2">
                  <label class="mb-0">
                    <input type="checkbox" id="enableSaturday" class="CheckboxClass mt-3"
                      formControlName="enableSaturday">
                    <p class="chkAlign mb-0 fw-700" style="margin-top: -27px !important">Saturday Only</p>
                  </label>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <ejs-grid #saturdayGrid id="saturdayGrid" [dataSource]="saturdayData" height="150" [allowFiltering]="false"
                            [allowPaging]="false">
                    <e-columns>
                      <e-column field="MarketDate" headerText="Market Date" textAlign="Left" width="120"></e-column>
                      <e-column field="RentBooth" headerText="Rent/Booth" textAlign="right" width="120">
                        <ng-template #template let-data>
                          <span>{{ data.RentBooth | currency:'USD':'symbol':'1.2-2' }}</span>
                        </ng-template>
                      </e-column>
                      <e-column field="NoOfBooths" headerText="# of Booths" textAlign="Left" width="120">
                        <ng-template #template let-data>
                          <label class="invisible" [for]="'SatNoOfBooth'+data.MarketDate">Both Sunday and Saturday No of Booth</label>
                          <input type="number" class="form-control text-left" [id]="'SatNoOfBooth'+data.MarketDate" [value]="data.NoOfBooths" min="0" max="999"
                            (input)="updateNoOfBooths($event, data, 'saturday')" [disabled]="!QBRForm.get('enableSaturday')?.value">
                        </ng-template>
                      </e-column>
                      <e-column field="Rent" headerText="Rent" textAlign="Right" width="120">
                        <ng-template #template let-data>
                          <span>{{ data.Rent | currency:'USD':'symbol':'1.2-2' }}</span>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>

              <!-- Sunday Section -->
              <div class="row">
                <div class="col-12 text-left mt-2">
                  <label class="mb-0">
                    <input type="checkbox" id="enableSunday" class="CheckboxClass mt-3" formControlName="enableSunday">
                    <p class="chkAlign mb-0 fw-700" style="margin-top: -27px !important">Sunday Only</p>
                  </label>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <ejs-grid #sundayGrid [dataSource]="sundayData" height="150" [allowFiltering]="false"
                    [allowPaging]="false" class="Table_Height_store table-striped table-ipad">
                    <e-columns>
                      <e-column field='MarketDate' headerText='Market Date' width=120></e-column>
                      <e-column field='RentBooth' headerText='Rent/Booth' textAlign='right' width=120>
                        <ng-template #template let-data>
                          <span>{{ data.RentBooth | currency:'USD':'symbol':'1.2-2' }}</span>
                        </ng-template>
                      </e-column>
                      <e-column field='NoOfBooths' headerText='# of Booths' textAlign='left' width=120>
                        <ng-template #template let-data>
                          <span class="dataName">
                            <label class="invisible" [for]="'SunNoOfBooth'+data.MarketDate">Both Sunday No of Booth</label>
                            <input type="number" class="form-control text-left"
                              [disabled]="!QBRForm.get('enableSunday')?.value" [id]="'SunNoOfBooth'+data.MarketDate" [value]="data.NoOfBooths" min="0" max="999"
                              (input)="updateNoOfBooths($event, data, 'sunday')">
                          </span>
                        </ng-template>
                      </e-column>
                      <e-column field='Rent' headerText='Rent' textAlign='right' width=120>
                        <ng-template #template let-data>
                          <span>{{ data.Rent | currency:'USD':'symbol':'1.2-2' }}</span>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>

              <!-- Both Section -->
              <div class="row">
                <div class="col-12 text-left mt-2">
                  <label class="mb-0">
                    <input type="checkbox" id="enableBoth" class="CheckboxClass mt-3" formControlName="enableBoth">
                    <p class="chkAlign mb-0 fw-700" style="margin-top: -27px !important">Both Saturday and Sunday</p>
                  </label>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <ejs-grid #bothGrid [dataSource]="bothData" height="150" [allowFiltering]="false" [allowPaging]="false"
                            class="Table_Height_store table-striped table-ipad">
                    <e-columns>
                      <e-column field='MarketDate' headerText='Market Date' textAlign='left' width=120></e-column>
                      <e-column field='RentBooth' headerText='Rent/Booth' textAlign='right' width=120>
                        <ng-template #template let-data>
                          <span>{{ data.RentBooth | currency:'USD':'symbol':'1.2-2' }}</span>
                        </ng-template>
                      </e-column>
                      <e-column field='NoOfBooths' headerText='# of Booths' textAlign='left' width=120>
                        <ng-template #template let-data>
                          <span class="dataName">
                            <label class="invisible" [for]="'SunSatNoOfBooth'+data.MarketDate">Both Sunday and Saturday No of Booth</label>
                            <input type="number" class="form-control text-left"
                              [disabled]="!QBRForm.get('enableBoth')?.value" [id]="'SunSatNoOfBooth'+data.MarketDate" [value]="data.NoOfBooths" min="0" max="999"
                              (input)="updateNoOfBooths($event, data, 'both')">
                          </span>
                        </ng-template>
                      </e-column>
                      <e-column field='Rent' headerText='Rent' textAlign='right' width=120>
                        <ng-template #template let-data>
                          <span>{{ data.Rent | currency:'USD':'symbol':'1.2-2' }}</span>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>
            </div>
            <div class="container mb-2">
              <div class="row mb-3">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left mt-3">
                  <span class="fw-700" style="font-size: 16px;">Total Rental Amount: ${{ totalAmount }}</span>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 respAlign mt-3">
                  <button class="btn btn-outline-primary mr-2" (click)="cancelQuickBoothRental()">Cancel</button>
                  <button class="btn btn-primary" (click)="showPayment();">Pay</button>
                </div>
              </div>
            </div>
          </div>
          <div #divPayment class="bgWghite shadow pt-2 mt-2" *ngIf="processPayment && showpayment"
            [ngStyle]="{ display: showpayment ? 'block' : 'none' }">
            <app-payment [keyedInTransaction]="true" [isQDR]="false" [MarketId]="marketId" [CCAmount]="totalAmount"
              [TransactionType]="transactionType" [voidPayment]="false" [VerifoneId]="verifoneId" [VendorId]="vendorId"
              (ClosePaymentPage)="ClosePaymentPage()" (PaymentResponse)="PaymentResponse($event)" (afterpaymentSuccessButn)="afterpaymentSuccessButn($event)"></app-payment>
          </div>
          <div #divRegisterPayment class="bgWghite shadow pt-2 mt-2" *ngIf="voidPayment"
            [ngStyle]="{ display: voidPayment ? 'block' : 'none' }">
            <app-payment [keyedInTransaction]="true" [isQDR]="IsQDR" [MarketId]="marketId" [VendorId]="vendorId"
              [CCAmount]="registrationFee.RegistrationFee" [TransactionType]="transactionType" [voidPayment]="voidPayment"
                         [VerifoneId]="verifoneId" (ClosePaymentPage)="ClosePaymentPage()"
              (PaymentResponse)="voidPaymentResponse()"></app-payment>
          </div>
          <div #divPayment class="bgWghite shadow pt-2 mt-2" *ngIf="openConfirmationPage">
            <app-rental-confirmation [VendorId]="vendorId" [newVendor]="false" [AccountReceipId]="0" [verifoneId]="verifoneId"
                  [QBRPayment]="true" [RentalType]="bookingPageRentalType"
                  ></app-rental-confirmation>
          </div>
          <div #divBidEntry class="bgWghite shadow pt-2 mt-2" [ngStyle]="{ display: showBidEntry ? 'block' : 'none' }"
            [formGroup]="bidEntryForm">

            <div class="container-fluid px-3">

              <!-- Bid Month row -->
              <div class="row align-items-center bid-month mb-2">
                <div class="col-12 col-sm-auto mb-2 mb-sm-0">
                  <label class="mb-0 font-weight-bold">Bid Month</label>
                </div>
                <div class="col-12 col-sm-4 col-md-3">
                  <ejs-dropdownlist id="WRBidMonth" [dataSource]="bidMonthList" formControlName="BidMonth"
                    [fields]="bidMonthFields" placeholder="Select Bid Month" (change)="onWRBidMonthChange($event)">
                  </ejs-dropdownlist>
                </div>
              </div>

              <!-- Vendor Info bar -->
              <div class="row align-items-center border-bottom pb-2 mb-2">
                <div class="col-md-auto col-sm-12 mb-1 mb-md-0">
                  <strong>Vendor ID:</strong> {{ vendorMarketID }}
                </div>
                <div class="col-md-auto col-sm-12 mb-1 mb-md-0">
                  <strong>Vendor Name:</strong> {{ vendorName }}
                </div>
                <div class="col-md-auto col-sm-12 mb-1 mb-md-0">
                  <strong>Badge Exp Date:</strong> {{ wrBadgeExpiryDate }}
                </div>
              </div>

              <!-- New Bid Entry card -->
              <div class="card p-3 mt-2">
                <div class="section-title-wr mb-2">New Bid Entry</div>

                <div class="row">
                  <div class="col-md-6 col-lg-3 mt-2">
                    <div class="form-group">
                      <label class="col-form-label pt-0" for="WRBidType">Bid Type</label>
                      <ejs-dropdownlist id="WRBidType" [dataSource]="wrBidTypeList" formControlName="BidType"
                        [fields]="bidTypeFields" placeholder="Select Bid Type" (change)="onWRBidTypeChange($event)">
                      </ejs-dropdownlist>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3 mt-2">
                    <div class="form-group">
                      <label class="col-form-label pt-0" for="WRBidName">Bid Name</label>
                      <input type="text" id="WRBidName" class="form-control" formControlName="BidName" readonly>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3 mt-2">
                    <div class="form-group">
                      <label class="col-form-label pt-0">Bid Date</label>
                      <ejs-datepicker format="MM/dd/yyyy" [allowEdit]="false" class="form-control p-0"
                        style="width:100%;" formControlName="BidDate">
                      </ejs-datepicker>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3 mt-2">
                    <div class="form-group">
                      <label class="col-form-label pt-0" for="WRBidAmount">Bid Amount</label>
                      <input type="text" id="WRBidAmount" class="form-control text-right" formControlName="BidAmount"
                        (focus)="onWRBidAmountFocus()" (blur)="onWRBidAmountBlur()"
                        (keydown)="onWRBidAmountKeyDown($event)">
                    </div>
                  </div>
                </div>

                <!-- Market Days -->
                <div class="d-flex flex-wrap wr-days-list mt-2">
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrSun" formControlName="Sun"
                      (change)="onWRChangeMarketDays('Sun')">
                    <label class="form-check-label" for="wrSun">Sun</label>
                  </div>
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrMon" formControlName="Mon"
                      (change)="onWRChangeMarketDays('Mon')">
                    <label class="form-check-label" for="wrMon">Mon</label>
                  </div>
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrTue" formControlName="Tue"
                      (change)="onWRChangeMarketDays('Tue')">
                    <label class="form-check-label" for="wrTue">Tue</label>
                  </div>
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrWed" formControlName="Wed"
                      (change)="onWRChangeMarketDays('Wed')">
                    <label class="form-check-label" for="wrWed">Wed</label>
                  </div>
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrThu" formControlName="Thu"
                      (change)="onWRChangeMarketDays('Thu')">
                    <label class="form-check-label" for="wrThu">Thu</label>
                  </div>
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrFri" formControlName="Fri"
                      (change)="onWRChangeMarketDays('Fri')">
                    <label class="form-check-label" for="wrFri">Fri</label>
                  </div>
                  <div class="form-check mr-3 mb-2">
                    <input class="form-check-input" type="checkbox" id="wrSat" formControlName="Sat"
                      (change)="onWRChangeMarketDays('Sat')">
                    <label class="form-check-label" for="wrSat">Sat</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-right mt-2">
                  <button *ngIf="wrIsEditMode" class="btn btn-primary mr-1"
                    (click)="wrDeleteSelectedRow()">Delete</button>
                  <button class="btn btn-primary mr-1" (click)="wrAddBidEntry()">
                    {{ wrIsEditMode ? 'Update' : 'Add' }}
                  </button>
                  <button class="btn btn-outline-primary mr-1" (click)="wrClearBidSection()">Clear</button>
                </div>
              </div>

              <!-- Grid -->
              <div class="row">
                <div class="col-12 text-left mt-2 mb-2">
                  <ejs-grid #wrGridBidEntry height="200" allowFiltering="true" allowSelection="true"
                    [dataSource]="wrBidEntryGridData" (rowSelected)="onWRGridRowSelect($event)"
                    [selectionSettings]="wrSelectionOptions">
                    <e-columns>
                      <e-column type="checkbox" headerText="" textAlign="center" width="50">
                        <ng-template #headerTemplate></ng-template>
                      </e-column>
                      <e-column field="BidType" headerText="Bid Type" textAlign="Left" width="120" i18n></e-column>
                      <e-column field="BidName" headerText="Bid Name" textAlign="Left" width="150" i18n></e-column>
                      <e-column field="BidDate" headerText="Bid Date" textAlign="Left" width="120" format="MM/dd/yyyy"
                        type="date" i18n></e-column>
                      <e-column field="MarketDay" headerText="Market Day" textAlign="Left" width="110" i18n></e-column>
                      <e-column field="BidAmount" headerText="Bid Amount" textAlign="Right" format="C2" width="120"
                        i18n></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>

              <!-- Save / Cancel -->
              <div class="row">
                <div class="col-12 text-right mt-1 mb-3">
                  <button class="btn btn-outline-primary mr-1" (click)="onWRBidMonthChange(null)">Cancel</button>
                  <button class="btn btn-primary" (click)="wrSaveBidEntry()"
                    [disabled]="!wrHasUnsavedChanges">Submit</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <app-bid-confirmation [visible]="showBidConfirmation" [vendorName]="vendorName" [vendorId]="vendorId"
      [bidMonthLabel]="wrBidMonthLabel" [submittedBids]="wrSubmittedBids" [receiptPdfBase64]="wrReceiptPdfBase64"
      (closeModal)="onBidConfirmationBack()">
    </app-bid-confirmation>

  </form>
</div>

<ng-template #VendorProductImages style="max-width: 50px;">
    <div class="modal-header">
        <h4 class="modal-title font-weight-normal" id="exampleModalLabel" i18n>Vendor products</h4>
        <button type="button" class="close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body ptb24" style="max-height: 400px;">
        <div class="row mx-0 mt-3">
            <div class="col-md-6 col-lg-4 mb-2" *ngFor="let item of VendorProductsImageList;let i = index">
                <div class="uploadPhoto ">
                    <div class="market_logo" style="position: relative;">
                        <span (click)="removeimage(i)" class="btn btn-danger edit_MarketLogo float-right"
                            style="bottom: auto !important; top: 5px !important;">
                            <i class="fa fa-close"></i>
                    </span>
                        <div class="market_img edit_vendor_image" style="height: auto !important;">
                            <img class="userIcon img-fluid" [src]="item.ProductImageUrl" loading="lazy" style="height: auto !important;" alt="User Icon">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4" *ngIf="VendorProductsImageList.length == 0">
                No Records
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary mr-3" (click)="modalRef.hide()">Cancel</button>
        </div>
    </div>
</ng-template>
